import { render } from "./BsLogoutView.vue?vue&type=template&id=7bf60874&scoped=true"
import script from "./BsLogoutView.vue?vue&type=script&lang=js"
export * from "./BsLogoutView.vue?vue&type=script&lang=js"

import "./BsLogoutView.vue?vue&type=style&index=0&id=7bf60874&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf60874"]])

export default __exports__